/* CTA footer: mobile accordion, back to top, country selector auto-submit. */
(() => {
  const mobile = window.matchMedia('(max-width: 767px)');

  function initFooter(root) {
    if (!root || root.dataset.ctaReady) return;
    root.dataset.ctaReady = 'true';

    root.querySelectorAll('[data-cta-footer-toggle]').forEach((toggle) => {
      toggle.addEventListener('click', () => {
        if (!mobile.matches) return;
        const expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!expanded));
      });
    });

    root.querySelectorAll('[data-cta-to-top]').forEach((link) => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
        document.querySelector('.skip-to-main, [data-cta-header] a')?.focus({ preventScroll: true });
      });
    });

    // One-time reveal as the footer scrolls into view
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reduce && 'IntersectionObserver' in window && !window.Shopify?.designMode) {
      root.classList.add('cta-ftr--animate');
      const observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          root.classList.add('is-in');
          observer.disconnect();
        }
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
      observer.observe(root);
    }

    root.querySelectorAll('[data-cta-autosubmit]').forEach((select) => {
      select.addEventListener('change', () => select.form?.submit());
    });
  }

  const boot = () => document.querySelectorAll('.cta-ftr').forEach(initFooter);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
